import { Container, Divider } from "@material-ui/core";
import axios from "axios";
import {
  ButtonGroupTop,
  CurrencyDisplay,
  CustomTable,
  DateTimeDisplay,
  ModalError,
  ModalSuccess,
  Page,
  StatusChip,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors, wordCapitalize } from "utils";
import AdminPotentialClaim from "pages/Admin/PotentialClaim";

const PotentialClaimLog = () => {
  const userRole = localStorage?.getItem("role");
  if (userRole === "admin") {
    return <AdminPotentialClaim />;
  }

  const classes = globalStyles();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const pageTitle = "Potential Claim Log";

  const [loadingPage, setLoadingPage] = useState(true);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    size: 10,
    search: "",
    sort: "",
  });
  const [dataTable, setDataTable] = useState([]);
  const [tablePageCount, setTablePageCount] = useState(1);

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };

  const getDataTable = async () => {
    setLoadingPage(true);
    try {
      const res = await axios.get(`${hardBaseUrl}/potential-claim/claim-logs`, {
        headers,
        params: queryParams,
      });
      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.size);
      setTablePageCount(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error));
    } finally {
      setLoadingPage(false);
    }
  };
  const handleRetryUnclaimProcess = async id => {
    setLoadingPage(true);
    try {
      ModalSuccess("Successfully Retry Potential Claim").then(() =>
        getDataTable(id)
      );
    } catch (error) {
      ModalError(getErrors(error));
    } finally {
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    getDataTable();
  }, [queryParams]);

  return (
    <Page className={classes?.root} title={pageTitle}>
      <Container maxWidth={false}>
        <HeaderTitle
          title={pageTitle}
          breadcrumbData={breadcrumbData({ pageTitle })}
        />
        <ButtonGroupTop />
        <Divider className={classes?.flatDivider} />
        <CustomTable
          isLoading={loadingPage}
          columnTable={columnTable}
          data={dataTable || []}
          page={queryParams?.page}
          pageSize={queryParams?.size}
          pageCount={tablePageCount}
          handleChangePage={(_, page) => handleChangeQueryParams(page, "page")}
          handleChangePageSize={e =>
            handleChangeQueryParams(e?.target?.value, "size")
          }
          isHaveAction
          handleView={item =>
            history.push(`/admin/publisher/potential-claim-log/${item?.id}`)
          }
          tooltipView="View Detail"
          disabledRestore={item => item.status !== "Error"}
          handleRestore={item => handleRetryUnclaimProcess(item?.id)}
          tooltipRestore="Retry Process"
          sortValue={queryParams?.sort}
          onRequestSort={sortBy =>
            handleChangeQueryParams(
              `${sortBy} ${
                queryParams.sort === `${sortBy} asc` ? "desc" : "asc"
              }`,
              "sort"
            )
          }
          mt={2}
        />
      </Container>
    </Page>
  );
};
const columnTable = [
  {
    name: "document_number",
    title: "Document Number",
    useSort: true,
    sort_key: "document_number",
  },
  {
    name: "dsp_name",
    title: "DSP",
    useSort: true,
    sort_key: "dsp_name",
  },
  {
    name: "total_streams_claimed",
    title: "Total Traffic",
    useSort: true,
    sort_key: "total_traffic",
    headerAlign: "right",
    renderText: item => <CurrencyDisplay value={item} />,
  },
  {
    name: "revenue_claimed",
    title: "Total Revenue",
    useSort: true,
    sort_key: "total_revenue",
    headerAlign: "right",
    renderText: item => <CurrencyDisplay value={item} prefix="Rp" />,
  },
  {
    name: "start_date",
    title: "Start Date",
    renderText: item => <DateTimeDisplay date={item} />,
  },
  {
    name: "end_date",
    title: "End Date",
    renderText: item => {
      if (!item) {
        return "-";
      }
      const dateObject = new Date(item);
      const isInvalidDate =
        isNaN(dateObject) || dateObject.getFullYear() < 2000;

      if (isInvalidDate) {
        return "-";
      }
      return <DateTimeDisplay date={item} />;
    },
  },
  {
    name: "status",
    title: "Status",
    renderText: status => (
      <StatusChip
        type={
          status === "finished"
            ? "success"
            : status === "time-out" || status === "error"
            ? "danger"
            : status === "started"
            ? "warning"
            : ""
        }
        label={
          status === "time-out" ? "Request Time Out" : wordCapitalize(status)
        }
      />
    ),
  },
];
export const breadcrumbData = ({ pageTitle }) => [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Potential Claim",
    link: "/admin/publisher/potential-claim-log",
  },
  {
    label: pageTitle,
    active: true,
  },
];
export default PotentialClaimLog;
